import React, { useState } from "react";

const CabBookingSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pickup: "",
    drop: "",
    date: "",
    passengers: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `
🚖 Rising Cab Service Booking Request

👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
📍 Pickup Location: ${formData.pickup}
🏁 Drop Location: ${formData.drop}
📅 Journey Date: ${formData.date}
👥 Passengers: ${formData.passengers}
    `;

    const whatsappUrl = `https://wa.me/919272511548?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <section
      className="space overflow-hidden"
      style={{
        backgroundImage: "url('/images/bg.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row gx-60 gy-40">
          <div className="col-lg-7 col-xl-7">
            <div className="contact-form-v1-wrap mb-4">
              <div className="title-area mb-35">
                <h4 className="sec-title mb-0">
                  Book Your Cab Now
                </h4>
                <p className="box-text">
                  Quick, safe and comfortable cab booking with
                  Rising Cab Service.
                </p>
              </div>

              <form
                onSubmit={handleSubmit}
                className="quote-form"
              >
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="name">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="phone">
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                      placeholder="Enter Mobile Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="pickup">
                      Pickup Location
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pickup"
                      name="pickup"
                      placeholder="Pickup Address"
                      value={formData.pickup}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="drop">
                      Drop Location
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="drop"
                      name="drop"
                      placeholder="Drop Address"
                      value={formData.drop}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
  <label htmlFor="date">Journey Date</label>
  <input
    type="date"
    className="form-control"
    id="date"
    name="date"
    value={formData.date}
    onChange={handleChange}
    min={new Date().toISOString().split("T")[0]}
    required
  />
</div>

                  <div className="form-group col-md-6">
                    <label htmlFor="passengers">
                      Number of Passengers
                    </label>
                    <select
                      className="form-control"
                      id="passengers"
                      name="passengers"
                      value={formData.passengers}
                      onChange={handleChange}
                      required
                    >
                      <option value="">
                        Select Passengers
                      </option>
                      <option value="1">1 Passenger</option>
                      <option value="2">2 Passengers</option>
                      <option value="3">3 Passengers</option>
                      <option value="4">4 Passengers</option>
                      <option value="5+">
                        5+ Passengers
                      </option>
                    </select>
                  </div>

                  <div className="col-12">
                    <ul className="contact-form__bottom">
                      <li>
                        <p>Service</p>
                        <p>Cab Booking</p>
                      </li>
                      <li>
                        <p>Availability</p>
                        <p>24/7</p>
                      </li>
                      <li>
                        <p>Support</p>
                        <p>Instant WhatsApp</p>
                      </li>
                    </ul>
                  </div>

                  <div className="form-btn col-12">
                    <button
                      type="submit"
                      className="th-btn bg-black w-100"
                    >
                      Book on WhatsApp
                      <i className="fas fa-arrow-up-right"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="contact-form__latest-info bg-theme">
              <div className="thumb">
                <img
                  src="/img/icon/client-img.png"
                  alt="client"
                />
              </div>

              <div className="content">
                <h6>
                  Hundreds of travelers trust Rising Cab Service
                  every day
                </h6>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-xl-5">
            <div className="contact-box-1-right">
              <div className="title-area text-white">
                <h2 className="sec-title text-whitee">
                  Need a Reliable Cab Service?
                </h2>

                <p>
                  Rising Cab Service offers local, outstation,
                  airport transfer, and corporate travel
                  services with professional drivers and
                  comfortable vehicles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CabBookingSection;